import React, { useState } from "react";
import "./portfolio.css";
import { projects } from "../../portfolio";

const Portfolio = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const renderProjects = (category) => {
    return projects
      .filter((project) => category === "all" || project.tab === category)
      .map((project, index) => (
        <div className="work__card" key={index}>
          <h3 className="work__title">{project.name}</h3>
          <p className="work__description">{project.description}</p>
          <p className="work__stack">{project.stack}</p>
          <a href={project.sourceCode} className="work__button">
            Code <i className="bx bx-right-arrow-alt work__button-icon"></i>
          </a>
        </div>
      ));
  };

  return (
    <section className="work section" id="portfolio">
      <h2 className="section__title">Projects</h2>
      <span className="section__subtitle">Recent works</span>
      <div className="work__filter">
        <span
          className={
            toggleState === 0 ? "work__item active-work" : "work__item"
          }
          onClick={() => toggleTab(0)}
        >
          All
        </span>
        <span
          className={
            toggleState === 1 ? "work__item active-work" : "work__item"
          }
          onClick={() => toggleTab(1)}
        >
          Frontend
        </span>
        <span
          className={
            toggleState === 2 ? "work__item active-work" : "work__item"
          }
          onClick={() => toggleTab(2)}
        >
          Backend
        </span>
      </div>

      <div className="work__container container work__content-active grid">
        {toggleState === 0 && renderProjects("all")}
        {toggleState === 1 && renderProjects("frontend")}
        {toggleState === 2 && renderProjects("backend")}
      </div>
    </section>
  );
};

export default Portfolio;
